import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NGODirectory from './pages/NGODirectory';
import BrandPartnerships from './pages/BrandPartnerships';
import DogsPage from './pages/DogsPage';
import AboutUs from './pages/AboutUs';
import HowToHelp from './pages/HowToHelp';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ngos" element={<NGODirectory />} />
            <Route path="/brands" element={<BrandPartnerships />} />
            <Route path="/dogs" element={<DogsPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/how-to-help" element={<HowToHelp />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
